export enum EnumTipoEnvio {
    ARQUIVO = 'ARQUIVO',
    LINHA_DIGITAVEL = 'LINHA_DIGITAVEL'
}



// WEBPACK FOOTER //
// ./src/app/resources/enum/enumTipoEnvio.ts